import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { SiteLogo } from '../components/SiteLogo';
import { LandingHero } from '../components/landing/LandingHero';
import { FormEmbed } from '../components/landing/FormEmbed';
import { PackageHighlights } from '../components/landing/PackageHighlights';
import { BravoFeature } from '../components/landing/BravoFeature';
import { PressLogos } from '../components/landing/PressLogos';
import { RealWeddings } from '../components/landing/RealWeddings';
import { TestimonialBand } from '../components/landing/TestimonialBand';
import { SiteFooter } from '../components/landing/SiteFooter';
import type { LandingVariant } from '../types/landing';
type LandingPageProps = {
  variant: LandingVariant;
};
export function LandingPage({
  variant
}: LandingPageProps) {
  useEffect(() => {
    document.title = variant.pageTitle;
    window.scrollTo(0, 0);
  }, [variant]);
  return <div className="min-h-screen w-full bg-white text-ink" data-id="element-127" data-mp="lmnz55sb5264">
      <header className="flex items-center justify-center border-b border-ink/10 px-6 py-4" data-id="element-128" data-mp="2zj6zd6jhbr69">
        <Link to={`/${variant.slug}`} aria-label="Twenty Mile House home" className="inline-block" data-id="element-129" data-mp="33kih6pw4383w">
          <SiteLogo size="sm" data-id="element-130" data-mp="38jlnserqpmdz" />
        </Link>
      </header>
      <main data-id="element-131" data-mp="38i22g9r88l5c">
        <LandingHero eyebrow={variant.eyebrow} headline={variant.headline} intro={variant.intro} data-id="element-132" data-mp="38him2xh864tf" />
        <FormEmbed lead={variant.formLead} data-id="element-133" data-mp="3dceq6vzqkimw" />
        <PackageHighlights stats={variant.stats} data-id="element-134" data-mp="3i9y7y5vn7djl" />
        <BravoFeature data-id="element-135" data-mp="3ibizrnqkoidr" />
        <PressLogos data-id="element-136" data-mp="3n8hr5yiuqb89" />
        <RealWeddings data-id="element-137" data-mp="3n7zvp440k11e" />
        <TestimonialBand data-id="element-138" data-mp="3n76mzxlhv1gm" />
      </main>
      <SiteFooter data-id="element-139" data-mp="3nacfznx8unhm" />
    </div>;
}